import { PageShell, PageHero } from '@/components/site/PageShell';
import { Seo } from '@/components/seo/Seo';
import { RichText } from '@/components/site/DocBody';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { faqGroups } from '@/content/faq';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqGroups.flatMap((g) =>
    g.items.map((it) => ({ '@type': 'Question', name: it.q, acceptedAnswer: { '@type': 'Answer', text: it.a } })),
  ),
};

export default function FaqPage() {
  return (
    <PageShell testId="faq-page">
      <Seo title="FAQ" description="Answers to common questions about DashLink Gaming: playable games, email verification, leaderboards, squads, voice notes, watch parties, privacy and account deletion." jsonLd={jsonLd} />
      <PageHero eyebrow="Help centre" title="Frequently asked questions">
        <p>Quick answers about playing, chatting and staying safe on DashLink.</p>
      </PageHero>
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-14">
        {faqGroups.map((g, gi) => (
          <section key={g.heading} data-testid={`faq-group-${gi}`}>
            <h2 className="font-heading text-xl font-bold tracking-tight text-[#09090B] mb-2">{g.heading}</h2>
            <Accordion type="multiple">
              {g.items.map((it, i) => (
                <AccordionItem key={it.q} value={`${gi}-${i}`} className="border-[#E4E4E7]">
                  <AccordionTrigger className="text-left text-[#09090B] hover:text-[#0047FF] hover:no-underline" data-testid={`faq-question-${gi}-${i}`}>
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#3F3F46] leading-relaxed" data-testid={`faq-answer-${gi}-${i}`}>
                    <RichText text={it.a} />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>
        ))}
      </div>
    </PageShell>
  );
}
